import React from 'react';
import { motion } from 'framer-motion';

const FeatureCard = ({ icon: Icon, title, description }) => {
  return (
    <motion.article
      className="relative flex flex-col items-center justify-center w-full max-w-[350px] h-[350px] mx-auto
                 max-sm:max-w-[120px] max-sm:h-[280px]"
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
    >
      {/* Circle background */}
      <div className="relative w-[320px] h-[320px] bg-white border-[3px] border-green-500 rounded-full flex flex-col items-center justify-center p-8 shadow-lg hover:shadow-xl transition-shadow duration-300
                      max-sm:w-[110px] max-sm:h-[110px] max-sm:p-2 max-sm:border-2">

        {/* Icon container */}
        <div className="relative mb-6 max-sm:mb-2">
          <div className="w-[100px] h-[100px] bg-[#FC8D89] rounded-full flex items-center justify-center shadow-md
                          max-sm:w-[30px] max-sm:h-[30px]">
            <Icon className="w-12 h-12 text-[#3338A0] stroke-[1.5]
                            max-sm:w-4 max-sm:h-4" />
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-slate-900 text-center mb-4 leading-tight max-w-[220px]
                       max-sm:text-xs max-sm:mb-1 max-sm:max-w-[90px] max-sm:leading-tight max-sm:font-semibold">
          {title}
        </h3>

        {/* Description */}
        <p className="text-sm text-gray-600 text-center leading-relaxed max-w-[240px]
                      max-sm:text-[8px] max-sm:max-w-[90px] max-sm:leading-tight max-sm:hidden">
          {description}
        </p>
      </div>

      {/* Mobile description below the circle */}
      <div className="sm:hidden mt-2 px-1">
        <p className="text-[10px] text-gray-600 text-center leading-tight max-w-[120px]">
          {description}
        </p>
      </div>
    </motion.article>
  );
};

export default FeatureCard;





// import React from 'react';
// import { motion } from 'framer-motion';

// const FeatureCard = ({ icon: Icon, title, description }) => {
//   return (
//     <motion.article
//       className="relative flex flex-col items-center justify-center w-full max-w-[350px] h-[350px] mx-auto"
//       whileHover={{ scale: 1.05 }}
//       transition={{ duration: 0.3 }}
//     >
//       {/* Circle background */}
//       <div className="relative w-[320px] h-[320px] bg-white border-[3px] border-green-500 rounded-full flex flex-col items-center justify-center p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">

//         {/* Icon container */}
//         <div className="relative mb-6">
//           <div className="w-[100px] h-[100px] bg-[#FC8D89] rounded-full flex items-center justify-center shadow-md">
//             <Icon className="w-12 h-12 text-[#3338A0] stroke-[1.5]" />
//           </div>
//         </div>

//         {/* Title */}
//         <h3 className="text-xl font-bold text-slate-900 text-center mb-4 leading-tight max-w-[220px]">
//           {title}
//         </h3>

//         {/* Description */}
//         <p className="text-sm text-gray-600 text-center leading-relaxed max-w-[240px]">
//           {description}
//         </p>
//       </div>
//     </motion.article>
//   );
// };

// export default FeatureCard;
